export class QuerystringHandler {
	private _queryString: string;
	private _queryStringData: any;

	constructor() {
		this.queryString = document.location.search.substring(1);
		try {
			this.queryStringData = this.getQueryParams(decodeURIComponent(this.queryString));
		} catch (error) {}
	}

	public set queryString(value: string) {
		this._queryString = value;
	}

	public get queryString(): string {
		return this._queryString;
	}

	public getValue(key: string): string {
		if (this.queryStringData[key]) {
			return this.queryStringData[key];
		}

		return '';
	}

	public set queryStringData(value: any) {
		this._queryStringData = value;
	}

	public get queryStringData(): any {
		return this._queryStringData;
	}

	private getQueryParams(queryString: string): any {
		const queryParameters = {};

		try {
			const data = queryString.split('&');
			for (const item of data) {
				const element = item.split('=');
				const key = element[0];
				const value = element[1];
				queryParameters[`${key}`] = value;
			}
		} catch (error) {
			// console.log('No querystring data found');
		}

		return queryParameters;
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/core/src/utils/QuerystringHandler.ts